import * as React from "react";
import { useEffect, useState, Fragment } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, CircularProgress } from "@mui/material";
import { s3baseUrl } from "src/config/config";
import ReactVideoPlayer from "src/components/ReactVideoPlayer/ReactVideoPlayer";
import { makeStyles } from "@mui/styles";
import { programme_workout_exercise_info_api } from "src/DAL/programmeWorkout/programmeWorkout";
import no_data_found from "src/assets/images/no_data_found.png";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backgroundColor: "white",
  },
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function ModalToShowAnExerciseInfo({ open, setOpen, Id }) {
  const [isLoading, setIsLoading] = useState(true);
  const [exercise, setExercise] = useState("");

  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
  };

  const handleGetInfo = async () => {
    let result = await programme_workout_exercise_info_api(Id);
    if (result.code == 200) {
      setExercise(result?.exercise);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open && Id) {
      setExercise("");
      handleGetInfo();
    }
  }, [open, Id]);

  return (
    <Fragment>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        scroll="body"
        maxWidth="md"
        BackdropProps={{
          classes: {
            root: classes.backdrop,
          },
        }}
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          },
        }}
      >
        <div
          className={`text-end mt-1 d-flex justify-content-end align-items-center`}
        >
          <IconButton
            className="back-screen-button me-1 "
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent>
          {isLoading ? (
            <div className="centered">
              <CircularProgress className={classes.loading2} color="primary" />
            </div>
          ) : !exercise ? (
            <DialogContentText id="alert-dialog-slide-description">
              <div className="centered">
                <div>
                  <img className="mx-auto" src={no_data_found} />
                  <p className="mt-3">{`Information Not Found`}</p>
                </div>
              </div>
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-slide-description">
              {exercise?.video_url ? (
                <ReactVideoPlayer url={exercise?.video_url} />
              ) : exercise?.gif_url ? (
                <div className="w-100 d-flex justify-content-center">
                  <img src={s3baseUrl + exercise?.gif_url} />
                </div>
              ) : (
                <img
                  width="100%"
                  src={s3baseUrl + exercise?.image?.thumbnail_1}
                />
              )}
            </DialogContentText>
          )}
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
